<template>
  <div class="crud_form_wrapper delivery">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.showDelivery") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h5 class="mt-5 font-weight-bold">
            {{ $t("TITLES.personal_data") }}
          </h5>
          <!-- Start:: Image Upload Input -->
          <div class="row">
            <div class="preview-container text-center my-3 col-6">
              <p class="mb-3">{{ $t("PLACEHOLDERS.personalImage") }}</p>
              <img
                @click="showImageModal(data.image.path)"
                v-if="data.image.path"
                col="6"
                :src="data.image.path"
                :alt="$t('PLACEHOLDERS.personalImage')"
              />
            </div>
            <div class="preview-container text-center my-3 col-6">
              <p class="mb-3">{{ $t("PLACEHOLDERS.id_image") }}</p>
              <img
                @click="showImageModal(data.idCard.path)"
                v-if="data.idCard.path"
                col="6"
                :src="data.idCard.path"
                :alt="$t('PLACEHOLDERS.id_image')"
              />
            </div>
          </div>
          <!-- End:: Image Upload Input -->

          <!-- Start:: First Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.first_name')"
            v-model.trim="data.firstName"
            disabled
          />
          <!-- End:: First Name Input -->

          <!-- Start:: Last Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.last_name')"
            v-model.trim="data.lastName"
            disabled
          />
          <!-- End:: Last Name Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />
          <!-- End:: Email Input -->

          <!-- Start:: Phone Input -->
          <base-input
            ref="phoneInput"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            disabled
          />
          <!-- End:: Phone Input -->

          <!-- Start:: Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            disabled
          />
          <!-- End:: Password Input -->

          <!-- Start:: Confirm Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.passwordConfirmation"
            disabled
          />
          <!-- End:: Confirm Password Input -->

          <!-- Start:: Account Status Switch -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Account Status Switch -->

          <!-- Start:: Bank Account Details -->
          <hr class="mt-5" style="width: 98%" />
          <h5 class="my-5 font-weight-bold">{{ $t("TITLES.bank_data") }}</h5>
          <base-select-input
            col="6"
            :optionsList="banks"
            :placeholder="$t('PLACEHOLDERS.bank_name')"
            v-model="data.bankName"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.bank_num')"
            v-model.trim="data.bankAccountNumber"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.iban')"
            v-model.trim="data.iban"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.identity')"
            v-model.trim="data.idNumber"
            disabled
          />
          <!-- End:: Bank Account Details -->

          <!-- Start:: Vehicle Details -->
          <hr class="mt-5" style="width: 98%" />
          <h5 class="my-5 font-weight-bold">{{ $t("TITLES.vechile_data") }}</h5>
          <base-select-input
            col="6"
            :optionsList="vehicleTypes"
            :placeholder="$t('PLACEHOLDERS.vechiles_type')"
            v-model="data.vehicleType"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.vehiclePlateNumber')"
            v-model.trim="data.vehiclePlateNumber"
            disabled
            v-if="!data.is_bicycle"
          />
          <div class="row" v-if="!data.is_bicycle">
            <div class="preview-container text-center my-3 col-6">
              <p class="mb-3">
                {{ $t("PLACEHOLDERS.vehicle_license_image_face") }}
              </p>
              <img
                @click="showImageModal(data.vehicleLicenseFront.path)"
                v-if="data.vehicleLicenseFront.path"
                col="6"
                :src="data.vehicleLicenseFront.path"
                :alt="$t('PLACEHOLDERS.vehicle_license_image_face')"
              />
            </div>
            <div class="preview-container text-center my-3 col-6">
              <p class="mb-3">
                {{ $t("PLACEHOLDERS.vehicle_license_image_back") }}
              </p>
              <img
                @click="showImageModal(data.vehicleLicenseBack.path)"
                v-if="data.vehicleLicenseBack.path"
                col="6"
                :src="data.vehicleLicenseBack.path"
                :alt="$t('PLACEHOLDERS.vehicle_license_image_back')"
              />
            </div>
          </div>
          <div class="row" v-if="!data.is_bicycle">
            <div class="preview-container text-center my-3 col-6">
              <p class="mb-3">
                {{ $t("PLACEHOLDERS.driving_license_image_face") }}
              </p>
              <img
                @click="showImageModal(data.driverLicenseFront.path)"
                v-if="data.driverLicenseFront.path"
                col="6"
                :src="data.driverLicenseFront.path"
                :alt="$t('PLACEHOLDERS.driving_license_image_face')"
              />
            </div>
            <div class="preview-container text-center my-3 col-6">
              <p class="mb-3">
                {{ $t("PLACEHOLDERS.driving_license_image_back") }}
              </p>
              <img
                @click="showImageModal(data.driverLicenseBack.path)"
                v-if="data.driverLicenseBack.path"
                col="6"
                :src="data.driverLicenseBack.path"
                :alt="$t('PLACEHOLDERS.driving_license_image_back')"
              />
            </div>
          </div>
          <!-- End:: Vehicle Details -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
    <image-modal
      v-if="dialogImage"
      :modalIsOpen="dialogImage"
      :modalImage="selectedItemImage"
      @toggleModal="dialogImage = !dialogImage"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EditDeliveryMan",

  data() {
    return {
      dialogImage: false,
      selectedItemImage: null,
      isWaitingRequest: false,
      initialData: null,
      data: {
        image: {
          path: null,
          file: null,
        },
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        password: null,
        passwordConfirmation: null,
        active: true,
        bankName: null,
        bankAccountNumber: null,
        iban: null,
        idNumber: null,
        vehicleType: null,
        vehiclePlateNumber: null,
        vehicleLicenseFront: {
          path: null,
          file: null,
        },
        vehicleLicenseBack: {
          path: null,
          file: null,
        },
        driverLicenseFront: {
          path: null,
          file: null,
        },
        driverLicenseBack: {
          path: null,
          file: null,
        },
        idCard: {
          path: null,
          file: null,
        },
        is_bicycle: this.vehicleType == "bicycle" ? true : false,
      },
      banks: [],
      vehicleTypes: [
        { id: 1, name: this.$t("VEHICLE_TYPES.bicycle"), value: "bicycle" },
        {
          id: 2,
          name: this.$t("VEHICLE_TYPES.motorcycle"),
          value: "motorcycle",
        },
        { id: 3, name: this.$t("VEHICLE_TYPES.car"), value: "car" },
      ],
    };
  },

  computed: {
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
  },

  methods: {
    showImageModal(image) {
      this.dialogImage = true;
      this.selectedItemImage = image;
    },
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `deliveries/${this.$route.params.id}`,
        });
        this.initialData = {
          id: 1,
          name: res.data.data.Delivery.vehicle_type_trans,
          value: res.data.data.Delivery.vehicle_type,
        };
        this.data.firstName = res.data.data.Delivery.first_name;
        this.data.lastName = res.data.data.Delivery.last_name;
        this.data.email = res.data.data.Delivery.email;
        this.data.phone = res.data.data.Delivery.mobile;
        this.data.bankName = res.data.data.Delivery.bank;
        this.data.bankAccountNumber = res.data.data.Delivery.account_number;
        this.data.iban = res.data.data.Delivery.iban;
        this.data.idNumber = res.data.data.Delivery.id_number;
        this.data.vehiclePlateNumber =
          res.data.data.Delivery.vehicle_plate_number;
        this.data.vehicleType = {
          id: 1,
          name: res.data.data.Delivery.vehicle_type_trans,
          value: res.data.data.Delivery.vehicle_type,
        };
        if (res.data.data.Delivery.vehicle_type == "bicycle") {
          this.data.is_bicycle = true;
        }
        this.data.active = res.data.data.Delivery.is_active;
        this.data.image.path = res.data.data.Delivery.image;
        this.data.idCard.path = res.data.data.Delivery.id_image;
        this.data.vehicleLicenseFront.path =
          res.data.data.Delivery.vehicle_license_image_face;
        this.data.vehicleLicenseBack.path =
          res.data.data.Delivery.vehicle_license_image_back;
        this.data.driverLicenseFront.path =
          res.data.data.Delivery.driving_license_image_face;
        this.data.driverLicenseBack.path =
          res.data.data.Delivery.driving_license_image_back;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getBanks() {
      try {
        const response = await this.$axios.get("/banks?page=0&limit=0");
        this.banks = response.data.data.data;
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    },
  },

  async created() {
    this.getDataToEdit();
    await this.getBanks();
  },
};
</script>
<style>
.delivery .preview-container p {
  color: #F7941E !important;
  font-size: 16px;
}
.delivery .preview-container img {
  padding: 10px;
  cursor: pointer;
}
</style>
